import Axios from 'api/client';
import qs from 'qs';
import { CustomField, CustomFieldGroup } from 'types/domain';
import { PaginatedData } from 'types/pagination';
import { FilterParams } from 'types/params';

interface FetchCustomFieldsParams extends Omit<FilterParams, 'scope'> {
    scope?: CustomFieldGroup;
    group?: CustomFieldGroup;
    source?: 'filters';
}

interface CreateCustomFieldParams
    extends Pick<
        CustomField,
        'title' | 'type' | 'group' | 'description' | 'answers' | 'default_value'
    > {}

type UpdateCustomFieldParams = CreateCustomFieldParams;

const fetchCustomFields = (accountId: number, params: FetchCustomFieldsParams) => {
    const { filters, ...restParams } = params;
    const stringifiedFilters = filters ? qs.stringify(filters) : '';

    return Axios.get<PaginatedData<CustomField>>(
        `/accounts/${accountId}/custom_fields?${stringifiedFilters}`,
        { params: restParams },
    ).then(response => response.data);
};

const fetchCustomField = (accountId: number, customFieldId: number) =>
    Axios.get<CustomField>(`/accounts/${accountId}/custom_fields/${customFieldId}`).then(
        response => response.data,
    );

const createCustomField = (accountId: number, params: CreateCustomFieldParams) =>
    Axios.post(`/accounts/${accountId}/custom_fields`, params).then(response => response.data);

const updateCustomField = (
    accountId: number,
    customFieldId: number,
    params: UpdateCustomFieldParams,
) =>
    Axios.patch(`/accounts/${accountId}/custom_fields/${customFieldId}`, params).then(
        response => response.data,
    );

const deleteCustomField = (accountId: number, customFieldId: number) =>
    Axios.delete(`/accounts/${accountId}/custom_fields/${customFieldId}`).then(
        response => response.data,
    );

const archiveCustomField = (accountId: number, customFieldId: number) =>
    Axios.post(`/accounts/${accountId}/custom_fields/${customFieldId}/archive`).then(
        response => response.data,
    );

const unarchiveCustomField = (accountId: number, customFieldId: number) =>
    Axios.post(`/accounts/${accountId}/custom_fields/${customFieldId}/unarchive`).then(
        response => response.data,
    );

export {
    fetchCustomFields,
    fetchCustomField,
    createCustomField,
    updateCustomField,
    deleteCustomField,
    archiveCustomField,
    unarchiveCustomField,
};
export type { FetchCustomFieldsParams };
